/* __next_internal_client_entry_do_not_use__ WinterMarketSecondaryLogo auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SVGIcon } from "@faire/web--source/slate/icons/SVGIcon";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { PromotionalEventType } from "@faire/web-api--source/indigofair/common/PromotionalEventType";
import React from "react";
export var WinterMarketSecondaryLogo = function(_param) {
    var isInverse = _param.isInverse, iconColor = _param.iconColor, rest = _object_without_properties(_param, [
        "isInverse",
        "iconColor"
    ]);
    var textColor = isInverse ? Core.text.inverse : eventsThemeColors[PromotionalEventType.FAIRE_WINTER_MARKET_2023].promoText;
    var snowflakeColor = iconColor !== null && iconColor !== void 0 ? iconColor : eventsThemeColors[PromotionalEventType.FAIRE_WINTER_MARKET_2023].badgeIcon;
    return /*#__PURE__*/ _jsxs(SVGIcon, _object_spread_props(_object_spread({
        width: "203",
        height: "143",
        viewBox: "0 0 203 143",
        fill: "none"
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 144.496V139.878L13.6359 135.699L0 131.3V127.562L13.6359 123.163L0 118.764V114.146L20.234 120.963V124.702L7.0379 129.321L20.234 133.94V137.678L0 144.496Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M0 102.049V97.6501H20.014V102.049H0Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.54004 79.8358L2.63971 75.877L16.9355 70.3786L5.05899 67.0796L6.15866 62.9008L25.293 68.3992L24.1933 71.9181L9.23775 77.6364L21.5541 81.1554L20.4544 85.3341L1.54004 79.8358Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M20.8951 44.6463L17.3762 49.4848L14.0771 47.0655L23.7543 33.6495L27.0533 36.0688L23.5343 40.9074L36.5105 50.3646L33.8713 53.8835L20.8951 44.6463Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M35.8486 21.9929L48.165 13.1955L50.3643 16.4945L41.5669 22.6527L43.9862 25.9517L51.6839 20.4533L53.8833 23.7524L46.1856 29.2507L48.6048 32.7697L57.4022 26.3916L59.6016 29.6906L47.2852 38.488L35.8486 21.9929Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M64.2208 5.49945L73.0182 3.08017C75.4375 2.42037 77.6368 2.42037 79.1764 3.52004C80.496 4.17984 81.5956 5.71939 82.0355 7.47886C82.9153 10.5579 81.8156 12.9772 79.6162 14.5168L86.2143 20.0151L81.3757 21.3347L75.4375 16.2762L72.1385 17.156L73.8979 23.3141L69.7192 24.4138L64.2208 5.49945ZM75.4375 12.3174C77.4169 11.6576 78.2966 10.338 77.8568 8.57853C77.4169 6.81906 75.8773 6.15925 73.678 6.81906L69.4993 7.91873L71.0388 13.4171L75.4375 12.3174Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M118.104 0L122.722 1.09967L125.802 10.5569L132.839 3.51895L137.458 4.61862L132.62 24.1928L128.441 23.0931L131.52 10.3369L124.042 17.3748L120.743 7.91764L117.664 20.4539L113.485 19.3542L118.104 0Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M160.553 17.1548L163.852 19.5741L159.014 40.9078L155.275 38.2686L156.375 33.6499L149.557 28.3715L145.378 31.0107L141.639 28.3715L160.553 17.1548ZM157.254 29.2512L159.014 22.4333L153.076 26.1722L157.254 29.2512Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M182.106 37.389L187.164 45.0867C188.484 47.2861 189.144 49.2655 188.704 51.025C188.484 52.5645 187.384 53.8841 185.845 54.9838C183.206 56.7433 180.566 56.5233 178.367 54.7639L175.068 62.6815L172.209 58.2828L175.068 51.2449L173.089 48.3858L167.81 51.9047L165.611 48.3858L182.106 37.389ZM179.027 50.1452C180.127 51.9047 181.886 52.3446 183.206 51.4648C184.745 50.3652 184.965 48.8256 183.645 47.0662L181.226 43.3273L176.388 46.4064L179.027 50.1452Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M198.6 67.74L199.699 71.9187L191.122 73.8982L201.459 79.8364L202.778 85.1148L192.441 79.1766L183.204 90.1733L181.885 85.1148L188.703 77.1972L185.843 75.4377L179.905 76.7573L178.806 72.5786L198.6 67.74Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M203 100.29V115.465H199.041V104.689H195.082V114.146H191.124V104.689H186.945V115.465H182.986V100.29H203Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M199.041 132.84V126.682H203V143.177H199.041V137.019H182.986V132.62H199.041V132.84Z",
                fill: textColor
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M146.697 101.027H121.844L137.239 85.4121L132.841 80.7935L112.607 101.027H104.909V94.2095L124.923 73.9755L120.524 69.3569L104.909 84.9723V59.2399H98.531V84.9723L82.9156 69.3569L78.297 73.9755L98.531 94.2095V101.027H91.4931L71.479 80.7935L66.8604 85.4121L82.4757 101.027H56.7434V107.406H82.4757L66.8604 123.021L71.479 127.42L91.4931 107.406H98.531V115.323L78.297 135.337L82.9156 139.956L98.531 124.341V149.193H104.909V124.341L120.524 139.956L124.923 135.337L104.909 115.323V107.406H112.607L132.841 127.42L137.239 123.021L121.844 107.406H146.697V101.027Z",
                fill: snowflakeColor
            })
        ]
    }));
};
